export default "__VITE_ASSET__O2V59RjC__"